import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GlobalNavbar from "./global/components/GlobalNavbar";
import Footer from "./global/components/Footer";
import Main from "./pages/main/Main";
import Blog from "./pages/blog/Routes";
import Services from "./pages/services/Routes";

function App() {
  return (
    <Router>
      <GlobalNavbar />
      <Routes>
        <Route exact path="/" element={<Main />} />
        <Route path="/blog/*" element={<Blog />} />
        <Route path="/services/*" element={<Services />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
